import { palette } from '../../../settings/themes/colors';
import popoverCardStyles from '../popoverCardStyles';

const styles = () => ({
  root: {
    ...popoverCardStyles,
    minWidth: 340,
    maxWidth: 380
  },
  badgeContent: {
    top: 10,
    right: 10,
    transform: 'none',
    transformOrigin: 'unset',
    height: 14,
    minWidth: 14,
    padding: '0 3px',
    fontSize: 9,
    lineHeight: '14px',
    fontWeight: 700
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  title: {
    fontWeight: 700
  },
  refreshSpinner: {
    color: palette.dimGray
  },
  subtitle: {
    display: 'block',
    color: palette.dimGray,
    marginBottom: 10
  },
  list: {
    maxHeight: 360,
    overflowY: 'auto'
  },
  seeMore: {
    marginTop: 8,
    paddingTop: 8,
    borderTop: `1px solid ${palette.platinum}`,
    '& button': {
      width: '100%',
      display: 'block'
    }
  },
  item: {
    padding: '10px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
    '&-info': {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 0
    },
    '&-side': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: 6,
      flexShrink: 0
    },
    '&-filename': {
      fontWeight: 600
    },
    '&-status': {
      fontSize: 12,
      fontWeight: 600,
      textTransform: 'uppercase'
    },
    '&-status_completed': {
      color: palette.emerald
    },
    '&-status_expired': {
      color: palette.dimGray
    },
    '&-status_processing': {
      color: palette.captuDataYellow
    },
    '&-status_failed': {
      color: palette.candy
    },
    '&-requested': {
      fontSize: 12,
      color: palette.dimGray
    },
    '&-divider': {
      marginTop: 10
    }
  },
  emptyState: {
    padding: '20px 0',
    textAlign: 'center',
    color: palette.dimGray
  }
});

export default styles;
